export enum SecEventType {
  Audio,
  Subtitles,
  Autopilot,
  Graphics,
  SCTE,
  Cuetone,
  FloatingMedia,
  ClosedCaptions,
}
